import CoreAPI from "manifest-components/src/api/coreAPI";
import APIAuth from "manifest-components/src/api/APIAuth";
import APIEmployer from "manifest-components/src/api/APIEmployer";
import APIIraRecommendation from "manifest-components/src/api/APIIraRecommendation";
import APITransfer from "manifest-components/src/api/APITransfer";
import APITransferInstruction from "manifest-components/src/api/APITransferInstruction";
import APIUser from "manifest-components/src/api/APIUser";
import APIAdmin from "manifest-components/src/api/APIAdmin";
import { envVariables, isLocalEnvironment } from "../env";
import Session from "./session";
import Authentication from "./authentication";

const coreAPI = new CoreAPI({
  useSentry: !isLocalEnvironment(),
  getSessionToken() {
    return Session.accessToken;
  },
  employerSearchUrl: envVariables.REACT_APP_EMPLOYER_SEARCH_URL,
  baseUrl: `${envVariables.REACT_APP_API_BASE_URL}`,
  authorizedCheck() {
    return Authentication.verify();
  },
  redirectAndThrowError: () => {
    Authentication.clear();
    window.location.href = "/error";
    throw new Error("Requires Authentication");
  },
});

const API = {
  auth: APIAuth(coreAPI),
  admin: APIAdmin(coreAPI),
  employer: APIEmployer(coreAPI),
  iraRecommendation: APIIraRecommendation(coreAPI),
  transfer: APITransfer(coreAPI),
  transferInstruction: APITransferInstruction(coreAPI),
  user: APIUser(coreAPI),
};

export default API;
